import React from 'react';

import LoginScreen from '../../components/login-screen';

const LoginPage = (props) => <LoginScreen {...props} />;

export default LoginPage;
